import axios from 'axios';
import config from '../config';

// Fetches the realm's enabled identity providers from the BFF's public
// /sso/config endpoint. Never throws — any failure resolves to [] so the login
// page can fall back to a single generic SSO button instead of breaking.
export async function getIdentityProviders() {
  try {
    const { data } = await axios.get(`${config.apiUrl}/sso/config`);
    return Array.isArray(data?.identity_providers) ? data.identity_providers : [];
  } catch (err) {
    console.error('Failed to fetch identity providers:', err);
    return [];
  }
}
